import styled from '@emotion/styled'
import { tokens } from '@news-mono/design-tokens'
import { breakpoint, calcRem, metrics } from '../../../__styling'
import { PNToastProps } from '../PNToastNotification.routing'

// PerthNow Colors
const pnColors = tokens.perthnow.colors
const pnPalette = pnColors.palette
// PerthNow Metrics
const pnMetrics = metrics.perthnow

export const StyledToastText = styled('p')<PNToastProps>(({ type, theme }) => ({
    color:
        type === 'success'
            ? pnPalette.greenJadeShade[600]
            : type === 'error' || type === 'warning'
            ? pnPalette.redCrisis[600]
            : type === 'verify'
            ? pnPalette.pinkThulite
            : pnPalette.blackShade[100],
    fontWeight: 600,
    letterSpacing: calcRem(-0.32),

    fontFamily: theme.fonts.sansSerif,
    fontSize: calcRem(pnMetrics.baseFontSize),
    lineHeight: calcRem(24),

    // Handle formatting on all clickable links below:
    a: {
        textDecorationLine: 'underline',
        cursor: 'pointer',
    },

    // Styling for mobile or larger
    [breakpoint('sm')]: {
        color:
            type === 'success'
                ? pnPalette.greenJadeShade[600]
                : type === 'error' || type === 'warning'
                ? pnPalette.redCrisis[600]
                : type === 'verify'
                ? pnPalette.pinkThuliteShade[600]
                : pnPalette.blackShade[100],
    },
}))
